import script from "./ViewWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./ViewWrapper.vue?vue&type=style&index=0&id=41a3f406&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a3f406"]])

export default __exports__